// extracted by mini-css-extract-plugin
export default {"topmenu_list":"Software_topmenu_list__tdT48","active":"Software_active__A2Ocd","features":"Software_features__Cmmjd"};